<template>
  <div class="common-wrap">
    <h1 class="logo">
      <img :src="logoImg" />
    </h1>
    <div class="reset-title">忘记密码</div>
    <div class="reset-title-img"><img :src="TitleImg" /></div>
    <!-- 重置密码区域 -->
    <div class="content-wrap">
      <div class="reset-password-wrapper">
        <box-header title="重置密码" />
        <div class="password-form-wrapper">
          <el-form
            :model="ruleForm"
            :label-position="labelPosition"
            status-icon
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item label="账号类型" prop="bid">
              <el-radio-group v-model="ruleForm.bid">
                <el-radio
                  v-for="item in accountTypeOptions"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <send-code-input
                v-model="ruleForm.phone"
                placeholder="请输入手机号"
                @send="sendCaptchaEdit"
                emptyTips="请输入手机号"
              />
            </el-form-item>
            <el-form-item label="验证码" prop="captcha">
              <el-input
                v-model="ruleForm.captcha"
                placeholder="请输入短信验证码"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                type="password"
                v-model="ruleForm.newPassword"
                placeholder="请输入8位以上的密码，且包含大小写字母、数字和特殊字符"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkNewPassword">
              <el-input
                type="password"
                v-model="ruleForm.checkNewPassword"
                placeholder="请输入"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item class="ruleForm-button">
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                :loading="loading"
                >确认</el-button
              >
              <el-button @click="onBack">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ACCOUNT_TYPE, accountTypeOptions } from "@/common/config";
import { SendCodeInput, BoxHeader } from "@ajx-common/trth-web-common";
import { sendResetPwdCaptcha, resetUpdatePassword } from "@/api";
export default {
  components: {
    SendCodeInput,
    BoxHeader,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkNewPassword !== "") {
          this.$refs.ruleForm.validateField("checkNewPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ACCOUNT_TYPE: Object.freeze(ACCOUNT_TYPE),
      accountTypeOptions: Object.freeze(accountTypeOptions),
      logoImg: require("@/assets/img/img_logo@2x.png"),
      TitleImg: require("@/assets/img/image_02@2x.png"),
      labelPosition: "top",
      loading: false,
      ruleForm: {
        bid: ACCOUNT_TYPE.ENT,
        phone: "",
        captcha: "",
        newPassword: "",
        checkNewPassword: "",
      },
      rules: {
        bid: [
          {
            required: true,
            message: "请选择账号类型",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        newPassword: [
          { validator: validatePass, trigger: "blur" },
          {
            required: true,
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+<>?]).{8,}$/,
            message: "请输入8位以上的密码，且包含大小写字母、数字和特殊字符",
            trigger: "blur",
          },
        ],
        checkNewPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 发送验证码
    sendCaptchaEdit() {
      console.log("发送验证码");
      sendResetPwdCaptcha({
        bid: this.ruleForm.bid,
        phone: this.ruleForm.phone,
      }).then((res) => {
        console.log("验证码已发送----", res);
        return this.$message.success("验证码已发送,请注意查收");
      });
    },
    // 确认按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.loading = true;
          const params = {
            bid: this.ruleForm.bid,
            phone: this.ruleForm.phone,
            captcha: this.ruleForm.captcha,
            newPassword: this.ruleForm.newPassword,
            confirmPassword: this.ruleForm.checkNewPassword,
          };
          console.log("修改密码params-----", params);
          resetUpdatePassword(params)
            .then((res) => {
              console.log("修改密码成功----", res);
              this.loading = false;
              this.dialogVisible = false;
              this.$message.success("密码修改成功");
              this.$router.replace({
                name: "Login",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 取消按钮
    onBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.common-wrap {
  .reset-title {
    position: absolute;
    top: 126px;
    right: 424px;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
  }
  .reset-title-img {
    position: absolute;
    top: 0;
    right: 204px;
    width: 220px;
    height: 220px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .content-wrap {
    padding: 200px 412px 112px;
    .reset-password-wrapper {
      background: #ffffff;
      border-radius: 16px;
      padding: 40px;
      box-sizing: border-box;
      .password-form-wrapper {
        margin-top: 24px;
        padding: 30px 250px;
        box-sizing: border-box;
        ::v-deep .el-form-item__label {
          padding: 0;
          margin-bottom: 8px;
          line-height: 18px;
        }
        .ruleForm-button {
          margin-top: 32px;
          ::v-deep .el-form-item__content {
            text-align: center;
            .el-button {
              width: 120px;
              height: 48px;
              margin: 0 20px;
            }
          }
        }
      }
    }
  }
}
</style>
